import { Grid, IconButton, Typography } from "../components";
import { ChevronLeftOutline, ChevronRightOutline, ExpandLessOutline, ExpandMoreOutline, } from "../icons";
import React from "react";
export const MapLayoutHeader = ({ inverted = false, vertical = true, header, onClick, customHeader, }) => {
    return (React.createElement(Grid, { container: true, alignItems: "center", flexWrap: "nowrap", flexDirection: inverted ? "row-reverse" : undefined, gap: 2, sx: {
            padding: 2,
            borderBottom: 1,
            borderColor: (theme) => theme.palette.stroke[100],
        } },
        customHeader ? (customHeader) : (React.createElement(Grid, { item: true, xs: true, minWidth: 0 },
            React.createElement(Typography, { variant: "title3", fontWeight: "bold", truncate: true }, header))),
        React.createElement(IconButton, { variant: "ghost", onClick: onClick, sx: {
                transform: "rotate(-90deg)",
                breakpoints: {
                    cmd: {
                        transform: "none",
                    },
                },
            } }, vertical ? (inverted ? (React.createElement(ChevronRightOutline, { size: "xs" })) : (React.createElement(ChevronLeftOutline, { size: "xs" }))) : inverted ? (React.createElement(ExpandLessOutline, { size: "xs" })) : (React.createElement(ExpandMoreOutline, { size: "xs" })))));
};
//# sourceMappingURL=MapLayoutHeader.js.map